import React from "react";
import { Link } from "react-router-dom";
import { isLink, isStatus, getStatusRowStyle } from "../../../../ui/helpers";

export function renderTestsRow(headings, item) {
  return headings.map(([key]) => (
    <td
      key={key}
      className={`align-middle no-line border-0 px-5 py-5 ${isStatus(key) &&
        getStatusRowStyle(item)}`}
    >
      {isLink(key) ? (
        <Link className="text-dark" to={`/tests/${item.id}`}>
          {item[key]}
        </Link>
      ) : (
        item[key]
      )}
    </td>
  ));
}

export const modifyAnalytes = (analytes) =>
  analytes.map((item) => ({
    ...item,
    level_of_reporting: [item.reporting_value, item.reporting_unit].join(" "),
  }));
